import classNames from "classnames";

import { AscBadgeColor, ignoreAttribute } from "@ascendnow/shared";

import styles from "./AscSimpleProgressBar.module.scss";

export interface AscSimpleProgressBarProps {
  value: number;
  max: number;
  fullWidth?: boolean;
  locked?: boolean;
  className?: string;
  color?: AscBadgeColor;
}

export default function AscSimpleProgressBar({
  value = 0,
  max = 100,
  fullWidth = false,
  color,
  className,
  locked,
}: AscSimpleProgressBarProps) {
  ignoreAttribute;
  return (
    <div
      className={classNames(
        styles.ground,
        {
          [styles.fullWidth]: fullWidth,
          [styles.teal]: color === "TEAL",
          [styles.pink]: color === "PINK",
          [styles.purple]: color === "PURPLE",
          [styles.green]: color === "GREEN",
          [styles.orange]: color === "ORANGE",
          [styles.locked]: locked,
        },
        className,
        { ...ignoreAttribute.contrast }
      )}
    >
      <div
        style={{ width: `${(value * 100) / (max || 1)}%` }}
        className={styles.progressBar}
        {...ignoreAttribute.contrast}
      />
    </div>
  );
}
